/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import dayjs from "dayjs";
import Config from "data/config";
import ModelEditContext from "components/model-selector/context";

function formatDate (date) {
    return dayjs(date).format(Config.dates.display.datetime);
}

const DialogPreviewPanel = () => {
    
    const ctx = useContext(ModelEditContext);
    const { selectedModel } = ctx;
    // const [imageUrl, setImageUrl] = useState('')

    // useEffect(() => {
    //     if (selectedImage) {
    //         setImageUrl(selectedImage.url)
    //         // setImageWidth(selectedImage.width)
    //     }
    // }, [selectedModel])
    
    return (
        <Fragment>
            {/*{!imageUrl ? (*/}
            {/*    <div className="simplicity-image-selector-window-preview-none">*/}
            {/*        No image selected*/}
            {/*    </div>*/}
            {/*) : (*/}
            <div className="simplicity-image-selector-window-preview">
                <div className="simplicity-image-selector-edit">
                    <div className="header">
                            Details
                    </div>
                        
                    {/*<ImageCover*/}
                    {/*    displayWidth="240"*/}
                    {/*    displayHeight="160"*/}
                    {/*/>*/}
                        
                    <div className="details">
                        <p><b>{selectedModel && selectedModel.file_name}</b></p>
                        <p><b>Created:</b> {selectedModel && formatDate(selectedModel.created_at)}</p>
                        <p><b>Modified:</b> {selectedModel && formatDate(selectedModel.updated_at)}</p>

                    </div>
                        
                    {/*<div className="header">*/}
                    {/*    Properties*/}
                    {/*</div>*/}
                    {/*<div className="preview-text">*/}
                    {/*    {selectedImage &&*/}
                    {/*        <ModelProperties/>*/}
                    {/*    }*/}
                    {/*</div>*/}
                </div>
            </div>
            {/*)}*/}
        </Fragment>
    );
};

export default DialogPreviewPanel;
